<template>
    <div class="all_order padding-20 bgc box-shadow">
        <div>
            <el-menu default-active="1" mode="horizontal" class="el-menu-demo">
                <el-menu-item index="1">全部订单</el-menu-item>
            </el-menu>
        </div>
        <div class="order_box">
            <div class="order_period order_div">
                <span>订单时间段</span>
                <el-date-picker
                    v-model="orderPeriod"
                    type="daterange"
                    range-separator="至"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期"
                    format="yyyy-MM-dd"
                    value-format="yyyy-MM-dd"
                ></el-date-picker>
            </div>
            <div class="order_status order_div">
                <span>订单状态</span>
                <el-select v-model="orderStatusValue" clearable placeholder="全部">
                    <el-option
                        v-for="item in orderStatusOptions"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value"
                    ></el-option>
                </el-select>
            </div>
            <div class="order_type order_div">
                <span>内容类型</span>
                <el-select v-model="mktypeValue" clearable placeholder="全部">
                    <el-option
                        v-for="item in mktypeOptions"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value"
                    ></el-option>
                </el-select>
            </div>
            <div class="goods_name order_div">
                <span>渠道</span>
                <el-input placeholder="输入渠道名" v-model="channelname" clearable></el-input>
            </div>
            <div class="goods_name order_div">
                <span>关键字</span>
                <el-input placeholder="输入订单号、名称" v-model="goodsName" clearable></el-input>
            </div>
            <div class="search_btn order_div">
                <el-button type="primary" @click="handleQuery" plain>搜索</el-button>
                <el-button type="primary" @click="resetClick()" plain>重置</el-button>
                <el-button type="primary" @click="exportClick()" plain>导出订单</el-button>
            </div>
        </div>
        <div class="goods_table_box">
            <div class="goods_table">
                <el-table :data="tableData" style="width: 100%" :default-sort = "{prop: 'date', order: 'descending'}">
                    <el-table-column label="商品名称" width="320">
                        <template slot-scope="scope">
                            <div class="table_left_box">
                                <div class="goods_img">
                                    <img v-lazy="scope.row.coverurl" alt="">
                                </div>
                                <div class="goods_info">
                                    <p :title="scope.row.kmcname">{{scope.row.kmcname}}</p>
                                    <label :class="orderKmctypeClass(scope.row.kmctype)">{{scope.row.kmctypetext}}</label>
                                </div>
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column prop="mktypetext" label="渠道" align='center' width="150">
                        <template slot-scope="scope">
                            <span>{{scope.row.channelname ? scope.row.channelname : '--'}}</span>
                        </template>
                    </el-table-column>
                    <el-table-column prop="orderno" label="订单号" sortable align='center'></el-table-column>
                    <el-table-column prop="datetime" label="订单时间" sortable align='center' width="94"></el-table-column>
                    <el-table-column label="订单状态" align='center'>
                        <template slot-scope="scope">
                            <span :class="statusClass(scope.row.status)">{{scope.row.statustext}}</span>
                        </template>
                    </el-table-column>
                    <el-table-column prop="uprice" label="价格" align='center'></el-table-column>
                    <el-table-column prop="finalpaymoney" label="实付" align='center'></el-table-column>
                    <el-table-column prop="paytypetext" label="支付方式" align='center'></el-table-column>
                    <el-table-column prop="customername" label="买家昵称" :formatter="formatter" align='center'></el-table-column>
                    <el-table-column label="操作" align='center'>
                        <template slot-scope="scope">
                            <el-button type="text" @click="orderDetails(scope.row.orderinnerid)">订单详情</el-button>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
            <page v-show="tableData.length > 0" :total="total" ref="page" @getList="searchClick"></page>
        </div>
    </div>
</template>

<script>
import {findAllList, exportList} from 'api/materialMgtApi'
import Page from 'base/page/page'
import {mapGetters, mapActions} from 'vuex'
import {dateFormat} from 'common/js/tools'
export default {
    name: 'AllOrder',
    data() {
        return {
            total: 0,
            orderStatusOptions: [
                {
                    value: '',
                    label: '全部'
                },
                {
                    value: 10,
                    label: '已完成'
                },
                {
                    value: 0,
                    label: '待付款'
                },
                {
                    value: 100,
                    label: '已取消'
                }
            ],
            orderStatusValue: '', // 订单状态
            mktypeOptions: [
                {
                    value: '',
                    label: '全部'
                },
                {
                    value: 1,
                    label: '图文'
                },
                {
                    value: 2,
                    label: '报告'
                },
                {
                    value: 3,
                    label: '直播'
                },
                {
                    value: 4,
                    label: '视频'
                },
                {
                    value: 5,
                    label: '专题'
                },
                {
                    value: 6,
                    label: '音频'
                },
                {
                    value: 7,
                    label: '课程'
                },
                {
                    value: 8,
                    label: '题库'
                }
            ],
            mktypeValue: '', // 内容类型
            goodsName: '', // 商品名称
            channelname: '', // 渠道名称
            orderPeriod: [], // 订单时间段  array
            tableData: []
        }
    },
    mounted() {
        if (this.$route.query.kmctype) {
            this.mktypeValue = Number(this.$route.query.kmctype)
        }
        this.getAllOrder()
    },
    methods: {
        formatter(row, column) {
            return row.customername
        },
        handleQuery() {
            this.total = 0
            this.$refs.page.handleSizeChange(1)
        },
        // 搜索按钮
        searchClick() {
            if (this.orderPeriod === null) {
                this.orderPeriod = []
            }
            // if (this.orderPeriod.length === 0 && this.orderStatusValue === '' && this.mktypeValue === '' && this.goodsName === '') {
            //     this.$message({type: 'warning', message: '请输入搜索内容'})
            //     return
            // }
            this.setLoading(true)
            var params = {
                beginTime: this.orderPeriod[0],
                endTime: this.orderPeriod[1],
                status: this.orderStatusValue,
                kmctype: this.mktypeValue,
                nickname: this.goodsName,
                channelname: this.channelname,
                kmcinnerid: this.$route.query.kmcinnerid ? this.$route.query.kmcinnerid : ''
            }
            findAllList({
                data: Object.assign({}, params, this.page),
                success: data => {
                    this.setLoading(false)
                    // console.log('搜索订单:', data)
                    this.tableData = data.data
                    this.total = data.pageableData.rowCount
                    // if (data.data.length !== 0) {
                    //     this.$message({type: 'success', message: data.msg})
                    // } else {
                    //     this.total = 0
                    //     this.$message({type: 'success', message: data.msg})
                    // }
                    if (data.data === '') {
                        this.tableData = []
                    }
                    if (data.pageableData === '') {
                        this.total = 0
                    }
                },
                error: data => {
                    this.setLoading(false)
                    console.log('error：', data)
                }
            })
        },
        // 重置按钮
        resetClick() {
            this.orderPeriod = []
            this.orderStatusValue = ''
            this.mktypeValue = ''
            this.goodsName = ''
            // this.setLoading(true)
            // findAllList({
            //     data: Object.assign({}, this.page),
            //     success: data => {
            //         this.total = data.pageableData.rowCount
            //         this.tableData = data.data
            //         this.setLoading(false)
            //     },
            //     error: data => {
            //         console.log('error：', data)
            //         this.setLoading(false)
            //     }
            // })
        },
        // 导出订单按钮
        exportClick() {
            // this.$message({type: 'success', message: '导出订单按钮'})
            if (this.orderPeriod === null) {
                this.orderPeriod = []
            }
            this.setLoading(true)
            var params = {
                beginTime: this.orderPeriod[0],
                endTime: this.orderPeriod[1],
                status: this.orderStatusValue,
                kmctype: this.mktypeValue,
                nickname: this.goodsName,
                channelname: this.channelname,
                kmcinnerid: this.$route.query.kmcinnerid ? this.$route.query.kmcinnerid : ''
            }
            exportList({
                data: Object.assign({}, params),
                success: data => {
                    this.setLoading(false)
                    let blob = new Blob([data], {type: 'application/vnd.ms-excel'})
                    let fileName = '交易订单' + dateFormat(new Date()) + '.xls'
                    if (window.navigator.msSaveOrOpenBlob) {
                        navigator.msSaveBlob(blob, fileName)
                    } else {
                        var link = document.createElement('a')
                        link.href = window.URL.createObjectURL(blob)
                        link.download = fileName
                        link.click() // 释放内存
                        window.URL.revokeObjectURL(link.href)
                    }
                },
                error: data => {
                    this.setLoading(false)
                    this.$message.error(data.msg)
                }
            })
        },
        // 跳转到订单详情
        orderDetails(value) {
            this.$router.push({name: 'OrderInfo', query: {orderinnerid: value}})
        },
        // 获取订单数据   默认页码  page：1  pagesize：10
        getAllOrder() {
            this.setLoading(true)
            var params = {
                kmctype: this.$route.query.kmctype ? this.$route.query.kmctype : '',
                kmcinnerid: this.$route.query.kmcinnerid ? this.$route.query.kmcinnerid : ''
            }
            findAllList({
                data: Object.assign({}, params, this.page),
                success: data => {
                    this.setLoading(false)
                    // console.log('全部订单:', data)
                    this.total = data.pageableData.rowCount
                    this.tableData = data.data
                    if (data.data === '') {
                        this.tableData = []
                    }
                    if (data.pageableData === '') {
                        this.total = 0
                    }
                },
                error: data => {
                    console.log('error：', data)
                    this.setLoading(false)
                }
            })
        },
        // 内容类型状态样式: 1图文 2报告 3直播 4视频 5专题
        orderKmctypeClass(value) {
            return 'graphic'
            // if (value === 1) {
            //     return 'graphic'
            // } else if (value === 2) {
            //     return 'report'
            // } else if (value === 3) {
            //     return 'live'
            // } else if (value === 4) {
            //     return 'video_lable'
            // } else if (value === 5) {
            //     return 'column_label'
            // } else {
            //     return 'star_label'
            // }
        },
        ...mapActions([
            'setLoading'
        ])
    },
    watch: {},
    filters: {},
    computed: {
        statusClass() {
            return function(value) {
                let cls = ''
                switch (value) {
                case 9:
                    cls = 'dzf_text_color'
                    break
                case 10:
                    cls = 'yzf_text_color'
                    break
                case 30:
                    cls = 'ywc_text_color'
                    break
                case 100:
                    cls = 'yqx_text_color'
                    break
                default:
                    cls = 'fail'
                }
                return cls
            }
        },
        ...mapGetters([
            'page',
            'user'
        ])
    },
    components: {
        Page
    }
}
</script>

<style lang="scss" type="text/scss" rel="stylesheet/scss">
@import "~common/scss/base";
@import "~common/scss/variable";
@import "~common/scss/mixin";
.all_order {
    padding-top: 0;
    .el-menu--horizontal>.el-menu-item.is-active {
        color: #409EFF;
    }
    .marginTop30 {
        margin-top: 30px;
    }
    .el-menu--horizontal > .el-menu-item {
        height: 48px;
        line-height: 48px;
    }
    .el-menu-item {
        padding: 0 10px;
    }
    .order_box {
        display: flex;
        flex-wrap: wrap;
        &>div{
            margin-top: 30px;
            span{
                white-space: nowrap;
            }
        }
        .el-input__icon {
            line-height: 2px;
        }
        .el-input__inner {
            height: 36px;
            line-height: 36px;
            width: 224px;
        }
        .el-date-editor .el-range-separator {
            padding: 0 10px;
            line-height: 28px;
        }
        .order_div {
            margin-right: 30px;
            height: 36px;
            vertical-align: middle;
            & > span {
                margin-right: 10px;
            }
        }
        .order_period {
            // width: 320px;
            .el-input__inner {
                width: 240px;
                // width: 230px;
                // width: 224px;
            }
            .el-date-editor .el-range-separator {
                color: #C0C4CC;
            }
            .el-date-editor .el-range-input, .el-date-editor .el-range-separator {
                height: auto;
            }
            .el-range-editor.el-input__inner {
                padding-right: 5px;
            }
            .el-date-editor .el-range-separator {
                padding: 0 5px;
            }
        }
        .goods_name{
            .el-input{
                width: auto;
            }
            .el-input__inner {
                width: 200px;
            }
            .el-input__icon {
                line-height: 36px;
            }
        }
        .order_status{
            .el-input__inner::placeholder {
                color: #303133;
            }
            .el-input__inner {
                width: 120px;
            }
        }
        .order_type{
            .el-input__inner::placeholder {
                color: #303133;
            }
            .el-input__inner {
                width: 120px;
            }
        }
        .search_btn{
            margin-right: 0px;
            .el-button, .el-button--mini {
                height: 36px;
            }
        }
    }
    .goods_table_box {
        margin-top: 30px;
        .goods_table {
            .dzf_text_color {
                color: #E6A23C;
            }
            .yzf_text_color {
                color: #67C23A;
            }
            .ywc_text_color {
                color: #409EFF;
            }
            .yqx_text_color {
                color: #F56C6C;
            }
            min-height: 600px;
            .el-table th>.cell {
                font-weight: bold!important;
                white-space: nowrap;
            }
            .el-table__empty-block {
                min-height: 360px;
            }
            .el-table__empty-text {
                box-sizing: border-box;
                line-height: 0px;
                padding-top: 150px;
            }
            .table_left_box{
                display: flex;
                .goods_img{
                    width: 106px;
                    min-width: 106px;
                    height: 60px;
                    margin-right: 10px;
                    img{
                        width: 100%;
                        height: 100%;
                    }
                }
                .goods_info{
                    min-width: 140px;
                    display: flex;
                    flex-direction: column;
                    justify-content: space-between;
                    box-sizing: border-box;
                    p{
                        height: 36px;
                        // text-overflow: ellipsis;
                        // white-space: nowrap;
                        line-height: 18px;
                        text-overflow: -o-ellipsis-lastline;
                        overflow: hidden;
                        text-overflow: ellipsis;
                        display: -webkit-box;
                        -webkit-line-clamp: 2;
                        line-clamp: 2;
                        -webkit-box-orient: vertical;
                    }
                    label{
                        width: 36px;
                        height: 16px;
                        line-height: 16px;
                        border-radius: 2px;
                        margin-right: 2px;
                        font-size: $font-12;
                        display: inline-block;
                        text-align: center;
                        color: $tcolor-white;
                    }
                    .report{
                        background: #E6A23C;
                    }
                    .video_lable{
                        background: $bgcolor-green;
                    }
                    .graphic{
                        background: #909399;
                    }
                    .column_label{
                        background: #F56C6C;
                    }
                    .live{
                        background: #409EFF;
                        width: 66px;
                    }
                    .star_label{
                        background: rgb(117, 84, 228);
                    }
                }
            }
        }
    }
}
</style>
